const BLUX_USER_ID = "blux_userId";
const BLUX_SESSION_ID = "blux_sessionId";

export class SessionStorage {
  static getBluxUserId(): string | null {
    const userId = sessionStorage.getItem(BLUX_USER_ID);
    return userId === "undefined" || userId?.trim() === "" ? null : userId;
  }

  static setBluxUserId(userId: string) {
    sessionStorage.setItem(BLUX_USER_ID, userId);
  }

  static getSessionId(): string | null {
    return sessionStorage.getItem(BLUX_SESSION_ID);
  }

  static setSessionId(sessionId: string) {
    sessionStorage.setItem(BLUX_SESSION_ID, sessionId);
  }
}
